export enum StepName {
  Congratulation = 'congratulation',
}
